import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Button } from '../../ui/button';
import { Clock, Plus, RefreshCw, Trash2 } from 'lucide-react';

/**
 * Admin waitlist panel — shown in List view only.
 * Parent owns fetch state and the onBookNow callback so we can hand the
 * waitlist entry straight into the Admin Booking modal.
 */
export const WaitlistPanel = ({
  waitlist,
  loading,
  onRefresh,
  onBookNow,
  onRemove,
}) => (
  <Card className="border border-slate-200">
    <CardHeader className="border-b border-slate-100">
      <div className="flex items-center justify-between">
        <CardTitle className="font-heading text-lg flex items-center gap-2">
          <Clock className="h-5 w-5 text-amber-500" />
          Lane Waitlist
        </CardTitle>
        <Button variant="outline" size="sm" onClick={onRefresh} disabled={loading}>
          <RefreshCw className={`h-4 w-4 mr-1 ${loading ? 'animate-spin' : ''}`} />
          Refresh
        </Button>
      </div>
    </CardHeader>
    <CardContent className="p-0">
      {loading ? (
        <div className="p-8 text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-4 border-blue-500 border-t-transparent mx-auto" />
        </div>
      ) : waitlist.length === 0 ? (
        <p className="p-4 text-slate-500 text-center">No customers on waitlist</p>
      ) : (
        <div className="divide-y divide-slate-100 max-h-96 overflow-y-auto">
          {waitlist.map((entry) => (
            <div key={entry.id} className="p-4 flex items-center justify-between hover:bg-slate-50" data-testid={`waitlist-${entry.id}`}>
              <div>
                <p className="font-medium text-slate-900">
                  {entry.customer_name || entry.user_name || 'Unknown Customer'}
                </p>
                <p className="text-sm text-slate-600">
                  {entry.customer_email || entry.user_email}
                </p>
                <p className="text-sm text-slate-500">
                  Lane {entry.lane_id} • {entry.date} • {entry.preferred_time || 'Any time'}
                </p>
                <p className="text-xs text-slate-400 mt-1">
                  Added: {new Date(entry.created_at).toLocaleDateString()}
                </p>
              </div>
              <div className="flex items-center gap-2">
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => onBookNow(entry)}
                  className="text-green-600 border-green-200 hover:bg-green-50"
                >
                  <Plus className="h-4 w-4 mr-1" />
                  Book Now
                </Button>
                <Button
                  variant="outline"
                  size="sm"
                  onClick={() => onRemove(entry.id)}
                  className="text-red-600 border-red-200 hover:bg-red-50"
                >
                  <Trash2 className="h-4 w-4" />
                </Button>
              </div>
            </div>
          ))}
        </div>
      )}
    </CardContent>
  </Card>
);

export default WaitlistPanel;
